import { IUser } from '@reverbdotcom/commons';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface BuyNowOptionClickAttributes {
  listingId: string;
  paymentMethod: string;
  user: Partial<IUser>;
  experiments?: string[];
}

export function trackBuyNowOptionClick({
  listingId,
  paymentMethod,
  user,
  experiments = [],
}: BuyNowOptionClickAttributes) {
  trackEvent({
    eventName: MParticleEventName.ClickedBuyItNowPaymentMethod,
    listingId,
    paymentMethod,
    experiments: formatExperimentsForEventAttributes(user, experiments),
  });
}
